(function () {

  // ---- VariantsJson se mediaId → color map ----
  function buildColorMap() {
    var map = {};
    try {
      var el = document.querySelector('[id^="VariantsJson-"]');
      if (!el) return map;
      JSON.parse(el.textContent).forEach(function (v) {
        if (v.featured_media && v.featured_media.id && v.option1) {
          map[String(v.featured_media.id)] = v.option1;
        }
      });
    } catch (e) {}
    return map;
  }

  // ---- Color radio select karo ----
  function selectColor(colorValue) {
    if (!colorValue) return;
    document.querySelectorAll(
      '.variant-input[data-index="option1"] input[type="radio"], input[name="Color"]'
    ).forEach(function (input) {
      if (input.value.trim() === colorValue && !input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        var label = document.querySelector('label[for="' + input.id + '"]');
        if (label) label.click();
      }
    });
  }

  // ---- Filename se color match (back image fallback) ----
  function getColorFromFilename(src) {
    if (!src) return null;
    var filename = decodeURIComponent(src.split('/').pop().split('?')[0]).toLowerCase();
    var matchedColor = null;
    var matchedLen = 0;
    document.querySelectorAll(
      '.variant-input[data-index="option1"] input[type="radio"], input[name="Color"]'
    ).forEach(function (input) {
      var key = input.value.trim().replace(/\s+/g, '_').toLowerCase();
      if (key && filename.indexOf(key) !== -1 && key.length > matchedLen) {
        matchedColor = input.value.trim();
        matchedLen = key.length;
      }
    });
    return matchedColor;
  }

  // ---- dataId se color nikalo ----
  function syncFromDataId(dataId, colorMap, fallbackSrc) {
    var color = colorMap[String(dataId)];
    if (color) { selectColor(color); return; }
    var fallback = getColorFromFilename(fallbackSrc);
    if (fallback) selectColor(fallback);
  }

  // ---- MAIN FIX: Swipe ke baad .slick-current se direct sync ----
  // currentSlide index se match nahi karte — seedha DOM se nikalo
  function syncFromCurrentSlide(colorMap) {
    // Step 1: Main slider ka current slide dekho
    var mainSlider = document.querySelector('[id^="ProductPhotos-"]');
    if (!mainSlider) return;

    var currentSlide = mainSlider.querySelector('.slick-current');
    if (!currentSlide) currentSlide = mainSlider.querySelector('.slick-active');
    if (!currentSlide) return;

    var img = currentSlide.querySelector('img.photoswipe__image, img.lazyloaded, img');
    if (!img) return;

    // img ka data-photoswipe-src sabse reliable hai
    var photoswipeSrc = img.getAttribute('data-photoswipe-src') || '';
    if (photoswipeSrc) {
      // Filename se color match karo
      var color = getColorFromFilename(photoswipeSrc);
      if (color) { selectColor(color); return; }
    }

    // Fallback: srcset se
    var srcset = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
    var firstSrc = srcset ? srcset.trim().split(',')[0].trim().split(' ')[0] : (img.getAttribute('src') || '');
    var fallbackColor = getColorFromFilename(firstSrc);
    if (fallbackColor) selectColor(fallbackColor);
  }

  function init() {
    var colorMap = buildColorMap();
    if (Object.keys(colorMap).length === 0) return;

    // --- Desktop + Mobile: Thumbnail click/touch ---
    document.querySelectorAll('a.product__thumb').forEach(function (link) {
      if (link._syncAttached) return;
      link._syncAttached = true;

      link.addEventListener('mousedown', function () {
        syncFromDataId(link.getAttribute('data-id'), colorMap, link.getAttribute('href'));
      });

      link.addEventListener('touchend', function () {
        syncFromDataId(link.getAttribute('data-id'), colorMap, link.getAttribute('href'));
      }, { passive: true });
    });

    if (!window.jQuery) return;

    // --- Mobile swipe: Main slider afterChange ---
    var $main = jQuery('[id^="ProductPhotos-"]');
    if ($main.length && !$main.data('colorSyncBound')) {
      $main.data('colorSyncBound', true);
      $main.on('afterChange.colorSync', function () {
        // 150ms wait karo — slick DOM update complete hone do
        setTimeout(function () {
          syncFromCurrentSlide(colorMap);
        }, 150);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var attempts = 0;
  var interval = setInterval(function () {
    init();
    attempts++;
    if (attempts >= 10) clearInterval(interval);
  }, 500);

})();